export const languages: {locale: string, title: string}[] = [
  {locale:"en", title: "English"},
  {locale:"fr", title: "French"},
  {locale: "de", title: "German"},
  {locale: "it", title: "Italian"},
  {locale: "es", title: "Spanish"},
  {locale: "pt", title: "Portuguese"},
  {locale: "nl", title: "Dutch"},
  {locale: "ru", title: "Russian"},
  {locale: "ja", title: "Japanese"},
]
